import { useState } from "react";
import Items from "./Items";
export default function PickingList({
  data,
  onDeleteItem,
  onToggleItem,
  onClearList,
}) {
  const [sortBy, setSortBy] = useState("input");
  let sortedItems;

  if (sortBy === "input") sortedItems = data;
  if (sortBy === "desc")
    sortedItems = data.slice().sort((a, b) => a.desc.localeCompare(b.desc));
  if (sortBy === "picked")
    sortedItems = data
      .slice()
      .sort((a, b) => Number(b.picked) - Number(a.picked));
  return (
    <div className="h-[330px] text-yellow-100 bg-yellow-800 text-center pt-6 w-full flex flex-col justify-between">
      <ul className="grid grid-cols-6">
        {sortedItems.map((item) => (
          <Items
            {...item}
            key={item.id}
            onDeleteItem={onDeleteItem}
            onToggleItem={onToggleItem}
          />
        ))}
      </ul>
      <div className="mb-6">
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="border-0 bg-yellow-900 rounded-2xl p-1 focus:outline-0 "
        >
          <option value="input">Sort by input order</option>
          <option value="desc">Sort by description</option>
          <option value="picked">Sort by picked items</option>
        </select>

        <button
          className="ml-3 bg-yellow-900  hover:bg-yellow-700 active:-translate-y-[2px] px-2 py-1 rounded-xl"
          onClick={onClearList}
        >
          Clear List
        </button>
      </div>
    </div>
  );
}
